import { Wand2, Sparkles, CircleDot, Candy, ArrowUpRight } from "lucide-react";

const services = [
  {
    id: "goochelshow",
    title: "Goochelshow",
    subtitle: "De klassieker",
    description:
      "Interactieve podiumshow met verdwijntrucs, verbluffende illusies en humor. Op maat voor kinderen, volwassenen of een gemengd publiek.",
    image: "https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/zzj18ul6__DSC2090.jpg",
    icon: Wand2,
    span: "lg:col-span-6",
    accent: "from-gold/30 via-gold/10",
  },
  {
    id: "tafelgoochelaar",
    title: "Tafelgoochelaar",
    subtitle: "Close-up magie",
    description:
      "Ik loop rond tussen de gasten en breng magie tot vlak voor hun neus — kaarten, munten en onmogelijke momenten, recht in de hand van het publiek.",
    image: "https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/gfn9cb5f_IMG-20250907-WA0013.jpg",
    icon: Sparkles,
    span: "lg:col-span-6",
    accent: "from-mystic/40 via-mystic/10",
  },
  {
    id: "circusanimatie",
    title: "Circusanimatie",
    subtitle: "Workshops & acts",
    description:
      "Circusworkshops waarin kinderen zélf leren jongleren en balanceren, of spectaculaire circusacts voor op je event — altijd actief, altijd leuk.",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_seppe-magic/artifacts/corxzdlc_20250930_174848.jpg",
    icon: CircleDot,
    span: "lg:col-span-6",
    accent: "from-gold/20 via-mystic/20",
  },
  {
    id: "suikerspin",
    title: "Suikerspin",
    subtitle: "Zoete magie",
    description:
      "Ik kom bij jou suikerspin draaien — verse, luchtige suikerspinnen die live gemaakt worden op je event. Perfect voor kinderfeesten, straatfeesten en fuiven.",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_seppe-magic/artifacts/10w5zwey_1000045166.jpg",
    icon: Candy,
    span: "lg:col-span-6",
    accent: "from-mystic/30 via-gold/10",
  },
];

export default function Services() {
  return (
    <section
      id="shows"
      className="relative py-24 sm:py-32 px-6 lg:px-10"
      data-testid="services-section"
    >
      <div className="absolute inset-0 star-field opacity-20 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-4">— De shows</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
            Kies jouw <span className="gold-text italic">magische</span> moment.
          </h2>
          <p className="mt-6 text-lg text-[#B5A9C9]">
            Vier formules, één doel: verwondering. Van grote podiumshow tot close-up
            magie, actieve circusanimatie of verse suikerspin — telkens op maat van
            jouw event.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-testid="services-grid">
          {services.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service }) {
  const { title, subtitle, description, image, icon: Icon, span, accent, id } = service;
  return (
    <a
      href="#boeken"
      className={`group relative overflow-hidden rounded-3xl glass p-0 block ${span} min-h-[420px] hover:border-gold/60 transition-all duration-500`}
      data-testid={`service-card-${id}`}
    >
      <div className="absolute inset-0">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
        />
        <div className={`absolute inset-0 bg-gradient-to-tr ${accent} to-transparent mix-blend-overlay`} />
        <div className="absolute inset-0 bg-gradient-to-t from-night via-night/80 to-transparent" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-between p-8 lg:p-10">
        <div className="flex items-start justify-between">
          <div className="w-12 h-12 rounded-xl glass flex items-center justify-center group-hover:-rotate-6 transition-transform duration-500">
            <Icon className="w-6 h-6 text-gold" />
          </div>
          <div className="w-10 h-10 rounded-full border border-gold/40 flex items-center justify-center group-hover:bg-gold group-hover:text-night-deep transition-all duration-500">
            <ArrowUpRight className="w-4 h-4" />
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-gold mb-3">{subtitle}</div>
          <h3 className="font-display text-3xl sm:text-4xl font-bold mb-3 group-hover:text-gold transition-colors duration-300">
            {title}
          </h3>
          <p className="text-[#B5A9C9] text-sm sm:text-base leading-relaxed max-w-xl">
            {description}
          </p>
        </div>
      </div>
    </a>
  );
}
